import moment from 'moment';
import React from 'react';

/*
Props : 
date = 'Published Date' <number>
*/
const DokanTableItemPublishedDate = ({ date, children }) => (
    <p className="text-xs text-tertiary font-light ">
        {children} <span className="text-secondary">{moment(date).format('DD MMM YYYY')}</span>
    </p>
);

export default DokanTableItemPublishedDate;
